import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d6df128"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-wild-sand p-x3 mb-x6 mx-auto max-w-750" }
const _hoisted_2 = { class: "text-12" }

import {
    BaseProductItem,
    CheckoutDeliverableType,
    CheckOutDeliverable,
    CheckOutDeliverableWithAddress,
    ClickAndCollectCheckOutDeliverable,
    CustomerDeliveryCheckOutDeliverable, EarliestCustomerDeliveryDates, LabelWithNamedArguments,
    PickUpCheckOutDeliverable,
} from '@/b2c/shared/api/server-apis';
import { Component, computed } from 'vue';
import CheckoutItem from '../items/CheckoutItem.vue';
import CheckoutItemSkeleton from '../items/CheckoutItemSkeleton.vue';
import { useCheckout } from '@/b2c/checkout/useCheckout';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';
import { useDeliverableLineItems } from '@/b2c/checkout/useDeliverableLineItems';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutDeliverableItems',
  props: {
    deliverable: null
  },
  setup(__props: any) {

const props = __props as {
    deliverable: CheckOutDeliverable | CheckOutDeliverableWithAddress | CustomerDeliveryCheckOutDeliverable | PickUpCheckOutDeliverable | ClickAndCollectCheckOutDeliverable;
}



const { deliveryInfo } = useCheckout();
const { deliverableLineItemsSortedByDeliveryDate } = useDeliverableLineItems();

const relatedDeliveryInfo = computed<EarliestCustomerDeliveryDates>(() => {
    return deliveryInfo.value[props.deliverable.id];
});

const skeletonOrItemComponent = computed<Component>(() => waitingForDeliveryInfo.value ? CheckoutItemSkeleton : CheckoutItem);

const sortedLineItems = computed<BaseProductItem[]>(() => deliverableLineItemsSortedByDeliveryDate(props.deliverable));
const waitingForDeliveryInfo = computed<boolean>(() => props.deliverable.type === CheckoutDeliverableType.CustomerDelivery && !relatedDeliveryInfo.value);

const getItemLabelByItemId = (id: number) => {
    const itemLabel = relatedDeliveryInfo.value?.labelForItems?.find((label) => label.itemId === id);
    return itemLabel?.label ?? {} as LabelWithNamedArguments;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'flex justify-center': _unref(sortedLineItems).length === 1, 'grid grid-cols-1 md:grid-cols-2 gap-y-x3 sm:gap-x-x4 sm:gap-y-x4': _unref(sortedLineItems).length > 1})
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedLineItems), (item) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(skeletonOrItemComponent)), {
          key: item.id,
          item: item,
          class: "flex"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(BlockLabelWithNamedArguments, {
                label: getItemLabelByItemId(item.id)
              }, null, 8, ["label"])
            ])
          ]),
          _: 2
        }, 1032, ["item"]))
      }), 128))
    ], 2),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})